// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"0e4d5e31","604":"3f0e852e","619":"48a0c3a1","804":"1fb9af3b"}[chunkId] + ".chunk.js";
};